"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioWebsocketServiceInstance = void 0;
const translations_1 = require("@front/application/globals/translations");
const client_1 = require("@rws-framework/client");
const WSService_audio_1 = __importStar(require("../WSService.audio"));
let AudioWebsocketService = class AudioWebsocketService extends client_1.RWSService {
    constructor(apiService, wsService) {
        super();
        this.apiService = apiService;
        this.wsService = wsService;
        this.activeSessions = new Map();
        this.listeners = new Map();
    }
    init() {
        this.setupWebSocketListeners();
    }
    destroy() {
        // Remove all listeners
        this.listeners.forEach((removeListener) => {
            removeListener();
        });
        this.listeners.clear();
        // Clean up sessions
        this.cleanup();
    }
    setupWebSocketListeners() {
        // Listen for various audio-related responses using the documented pattern
        this.listeners.set('audio_stream_started', this.wsService.listenForMessage('audio', (wsResponse) => {
            console.log('Received audio response:', wsResponse);
        }, 'audio_stream_started'));
        this.listeners.set('audio_stream_ended', this.wsService.listenForMessage('audio', (wsResponse) => {
            this.handleStreamEnded(wsResponse);
        }, 'audio_stream_ended'));
        this.listeners.set('audio_chunk_received', this.wsService.listenForMessage('audio', (wsResponse) => {
            this.handleChunkReceived(wsResponse);
        }, 'audio_chunk_received'));
        this.listeners.set('audio_transcription_complete', this.wsService.listenForMessage('audio', (wsResponse) => {
            this.handleTranscriptionComplete(wsResponse);
        }, 'audio_transcription_complete'));
        this.listeners.set('audio_stream_error', this.wsService.listenForMessage('audio', (wsResponse) => {
            this.handleStreamError(wsResponse);
        }, 'audio_stream_error'));
        this.listeners.set('live_chunk_processed', this.wsService.listenForMessage('audio', (wsResponse) => {
            this.handleLiveChunkProcessed(wsResponse);
        }, 'live_chunk_processed'));
        this.listeners.set('audio_transcription_error', this.wsService.listenForMessage('audio', (wsResponse) => {
            this.handleTranscriptionError(wsResponse);
        }, 'audio_transcription_error'));
    }
    /**
     * Start an audio streaming session
     */
    async startAudioStream(sessionId, language = 'en', format = 'webm', voiceId, options = {}) {
        var _a;
        try {
            // Store callbacks for this session
            this.activeSessions.set(sessionId, options);
            // Send message using the documented pattern
            this.wsService.sendMessage('audio', 'start_audio_stream', {
                sessionId,
                language,
                format,
                voiceId
            });
            return true;
        }
        catch (error) {
            console.error('Failed to start audio stream:', error);
            (_a = options.onError) === null || _a === void 0 ? void 0 : _a.call(options, error.message);
            return false;
        }
    }
    /**
     * Send audio chunk to the server
     */
    async sendAudioChunk(sessionId, audioBlob, chunkId, isLastChunk = false) {
        var _a;
        try {
            // Convert blob to base64
            const audioData = await this.blobToBase64(audioBlob);
            this.wsService.sendMessage('audio', 'audio_stream_chunk', {
                sessionId,
                audioData,
                chunkId,
                isLastChunk
            });
            return true;
        }
        catch (error) {
            console.error('Failed to send audio chunk:', error);
            const callbacks = this.activeSessions.get(sessionId);
            (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onError) === null || _a === void 0 ? void 0 : _a.call(callbacks, error.message);
            return false;
        }
    }
    /**
     * End an audio streaming session
     */
    async endAudioStream(sessionId) {
        var _a;
        try {
            this.wsService.sendMessage('audio', 'end_audio_stream', {
                sessionId
            });
            return true;
        }
        catch (error) {
            console.error('Failed to end audio stream:', error);
            const callbacks = this.activeSessions.get(sessionId);
            (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onError) === null || _a === void 0 ? void 0 : _a.call(callbacks, error.message);
            return false;
        }
    }
    /**
     * Send live audio chunk for real-time processing
     */
    async sendLiveAudioChunk(sessionId, audioBlob, chunkId) {
        var _a;
        try {
            const audioData = await this.blobToBase64(audioBlob);
            this.wsService.sendMessage('audio', 'live_audio_chunk', {
                sessionId,
                audioData,
                chunkId
            });
            return true;
        }
        catch (error) {
            console.error('Failed to send live audio chunk:', error);
            const callbacks = this.activeSessions.get(sessionId);
            (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onError) === null || _a === void 0 ? void 0 : _a.call(callbacks, error.message);
            return false;
        }
    }
    /**
     * Stream recorded audio data in chunks
     */
    async streamRecordedAudio(sessionId, audioBlob, chunkSize = 64 * 1024, // 64KB chunks
    options = {}) {
        var _a;
        try {
            // Start the stream
            await this.startAudioStream(sessionId, (0, translations_1.getLanguage)().toLowerCase(), 'webm', undefined, options);
            // Convert blob to array buffer
            const arrayBuffer = await audioBlob.arrayBuffer();
            const totalSize = arrayBuffer.byteLength;
            const totalChunks = Math.ceil(totalSize / chunkSize);
            // Send audio in chunks
            for (let i = 0; i < totalChunks; i++) {
                const start = i * chunkSize;
                const end = Math.min(start + chunkSize, totalSize);
                const chunkBuffer = arrayBuffer.slice(start, end);
                const chunkBlob = new Blob([chunkBuffer]);
                const isLastChunk = i === totalChunks - 1;
                await this.sendAudioChunk(sessionId, chunkBlob, i, isLastChunk);
                // Small delay between chunks to avoid overwhelming the server
                if (!isLastChunk) {
                    await new Promise(resolve => setTimeout(resolve, 10));
                }
            }
            return true;
        }
        catch (error) {
            console.error('Failed to stream recorded audio:', error);
            (_a = options.onError) === null || _a === void 0 ? void 0 : _a.call(options, error.message);
            return false;
        }
    }
    // Event handlers based on WSResponse format
    handleStreamStarted(wsResponse) {
        var _a, _b;
        try {
            if ((_a = wsResponse.data) === null || _a === void 0 ? void 0 : _a.sessionId) {
                const callbacks = this.activeSessions.get(wsResponse.data.sessionId);
                (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onStreamStarted) === null || _b === void 0 ? void 0 : _b.call(callbacks, wsResponse.data.sessionId);
            }
        }
        catch (error) {
            console.error('Error handling stream started:', error);
        }
    }
    handleStreamEnded(wsResponse) {
        var _a, _b;
        try {
            if ((_a = wsResponse.data) === null || _a === void 0 ? void 0 : _a.sessionId) {
                const callbacks = this.activeSessions.get(wsResponse.data.sessionId);
                (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onStreamEnded) === null || _b === void 0 ? void 0 : _b.call(callbacks, wsResponse.data.sessionId);
                // Clean up session callbacks
                this.activeSessions.delete(wsResponse.data.sessionId);
            }
        }
        catch (error) {
            console.error('Error handling stream ended:', error);
        }
    }
    handleChunkReceived(wsResponse) {
        var _a, _b;
        try {
            if ((_a = wsResponse.data) === null || _a === void 0 ? void 0 : _a.sessionId) {
                const callbacks = this.activeSessions.get(wsResponse.data.sessionId);
                (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onChunkProcessed) === null || _b === void 0 ? void 0 : _b.call(callbacks, wsResponse.data.sessionId);
            }
        }
        catch (error) {
            console.error('Error handling chunk received:', error);
        }
    }
    handleTranscriptionComplete(wsResponse) {
        var _a, _b;
        try {
            if ((_a = wsResponse.data) === null || _a === void 0 ? void 0 : _a.sessionId) {
                const callbacks = this.activeSessions.get(wsResponse.data.sessionId);
                (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onTranscriptionComplete) === null || _b === void 0 ? void 0 : _b.call(callbacks, wsResponse.data.transcription, wsResponse.data.audioResponse);
            }
        }
        catch (error) {
            console.error('Error handling transcription complete:', error);
        }
    }
    handleStreamError(wsResponse) {
        var _a, _b, _c;
        try {
            const sessionId = (_a = wsResponse.data) === null || _a === void 0 ? void 0 : _a.sessionId;
            if (sessionId) {
                const callbacks = this.activeSessions.get(sessionId);
                (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onError) === null || _b === void 0 ? void 0 : _b.call(callbacks, ((_c = wsResponse.data) === null || _c === void 0 ? void 0 : _c.error) || 'Unknown stream error');
            }
        }
        catch (error) {
            console.error('Error handling stream error:', error);
        }
    }
    handleTranscriptionError(wsResponse) {
        var _a, _b, _c;
        try {
            const sessionId = (_a = wsResponse.data) === null || _a === void 0 ? void 0 : _a.sessionId;
            if (sessionId) {
                const callbacks = this.activeSessions.get(sessionId);
                (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onError) === null || _b === void 0 ? void 0 : _b.call(callbacks, ((_c = wsResponse.data) === null || _c === void 0 ? void 0 : _c.error) || 'Transcription error');
            }
        }
        catch (error) {
            console.error('Error handling transcription error:', error);
        }
    }
    handleLiveChunkProcessed(wsResponse) {
        var _a, _b;
        try {
            if ((_a = wsResponse.data) === null || _a === void 0 ? void 0 : _a.sessionId) {
                const callbacks = this.activeSessions.get(wsResponse.data.sessionId);
                (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onChunkProcessed) === null || _b === void 0 ? void 0 : _b.call(callbacks, wsResponse.data.sessionId);
            }
        }
        catch (error) {
            console.error('Error handling live chunk processed:', error);
        }
    }
    // Utility methods
    async blobToBase64(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64 = reader.result.split(',')[1];
                resolve(base64);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }
    /**
     * Check if a session is active
     */
    isSessionActive(sessionId) {
        return this.activeSessions.has(sessionId);
    }
    /**
     * Get active session IDs
     */
    getActiveSessions() {
        return Array.from(this.activeSessions.keys());
    }
    /**
     * Clean up all sessions
     */
    cleanup() {
        this.activeSessions.clear();
    }
};
exports.AudioWebsocketServiceInstance = AudioWebsocketService;
exports.AudioWebsocketServiceInstance = AudioWebsocketService = __decorate([
    __param(0, client_1.ApiService),
    __param(1, WSService_audio_1.default),
    __metadata("design:paramtypes", [typeof (_a = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _a : Object, typeof (_b = typeof WSService_audio_1.WSServiceAudioInstance !== "undefined" && WSService_audio_1.WSServiceAudioInstance) === "function" ? _b : Object])
], AudioWebsocketService);
exports.default = AudioWebsocketService.getSingleton();
